<div class="w-full h-[calc(100vh-140px)]">
  <iframe *ngIf="iframeUrl" [src]="iframeUrl" class="w-full h-full border-0" title="Subscription Manager"></iframe>
</div>
